/**
 * Subscription status of the billing account that owns an organization. The backend keeps a
 * client-readable copy at `organizations/{orgId}/account_status/current`; it never rejects
 * writes, so the PWA enforces read-only mode itself.
 */
export const ACCOUNT_STATUSES = {
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  READ_ONLY: 'read_only',
  SUSPENDED: 'suspended',
  CANCELLED: 'cancelled',
} as const;

export type AccountStatusCode = (typeof ACCOUNT_STATUSES)[keyof typeof ACCOUNT_STATUSES];

/** Raw Firestore shape of `organizations/{orgId}/account_status/current`. */
export interface AccountStatusSnapshotDTO {
  accountId?: string;
  status?: string;
  trialEndsAt?: unknown;
  graceEndsAt?: unknown;
  updatedAt?: unknown;
}

export interface AccountStatusSnapshot {
  accountId: string | null;
  status: AccountStatusCode;
  trialEndsAt: Date | null;
  graceEndsAt: Date | null;
  updatedAt: Date | null;
}

export interface AccountStatusState {
  snapshot: AccountStatusSnapshot;
  /** False until the first snapshot (or error) arrives for the active organization. */
  loaded: boolean;
  /** False in read_only, suspended and cancelled: create, update and delete are hidden. */
  writable: boolean;
}
